import collect from 'collect.js';
const calpak = window.calpak

"use strict";
if (window.debug) console.log("search.js loaded");

const headerSearchPlaceholders = document.querySelector(
  ".site-header__menu-item .search-placeholders__inner"
);
if (headerSearchPlaceholders) {
  let searchPlaceholders = document.querySelector(
    ".search-input__container .search-placeholders"
  );
  searchPlaceholders.setAttribute(
    "data-num",
    headerSearchPlaceholders.parentNode.getAttribute("data-num")
  );
  searchPlaceholders.querySelector(".search-placeholders__inner").innerHTML =
    headerSearchPlaceholders.innerHTML;
}
var searchtitle = document.querySelector(".search-section .search_title");
var mobilesearchTitle = document.querySelector(
  ".menu-popup__mobile-nav .mobile-header"
);

const color_groups_search = {
  black: [
    "black",
    "trnk-black",
    "matte-black",
    "ambeur-black",
    "luka-black",
    "brushed-black",
    "wavy",
    "eclipse",
    "cheetah",
    "plaid",
    "obsidian",
    "onyx",
    "midnight-marble",
  ],
  pink: [
    "pink",
    "watermelon",
    "modern-abstract",
    "dragonfruit",
    "pink-sand",
    "rose",
    "retro-sunset",
    "pink-gold",
    "pink-n-gold",
    "canyon",
    "guava",
    "petal",
    "rosewood-tie-dye",
    "cappuccino-tie-dye",
    "things-between",
    "bloom",
    "rose-quartz",
    "rosewood",
    "bubblegum",
    "blush",
    "blush-pink",
    "bon-voyage",
    "terracotta",
    "aurora-pink",
    "confetti",
    "floral",
    "rose-gold",
    "shimmer-pink",
    "stripe",
    "sunset",
    "mauve",
    "sorbet",
    "jen-pink",
    "shell-pink",
    "pink-grid",
    "tea-rose",
    "persimmon",
    "blossom",
    "raspberry",
    "coral",
    "tea-rose"
  ],
  "rose-gold": ["rose-gold", "rosewood-tie-dye", "jen-pink"],
  cacao: ["cacao"],
  flame: ["flame"],
  storm: ["storm"],
  brown: [
    "papaya",
    "ginger",
    "khaki",
    "taupe",
    "walnut",
    "espresso",
    "trnk-espresso",
    "sand-tide",
    "pumpkin",
    "gingham",
    "mocha",
    "rust",
    "cognac",
    "eclipse",
    "cheetah",
    "chocolate",
    "hazel",
    "sand-tie-dye",
    "sand-tie-dye-wash",
    "bronze",
    "kaya-bronze",
    "caramel",
    "leopard",
    "burgundy",
    "toffee",
    "copper",
    "greige",
  ],
  beige: [
    "beige",
    "white-sands",
    "nude",
    "linen",
    "speckle",
    "dune",
    "sand-tide",
    "gingham",
    "oatmeal",
    "cappuccino-tie-dye",
    "polka-dot",
    "sand-tie-dye",
    "sand-tie-dye-wash",
    "trnk-almond",
    "trnk-nude",
    "cream",
    "gold-marble",
    "sand",
    "stone",
    "terrazzo",
    "bronze",
    "kaya-bronze",
    "birch",
    "greige",
  ],
  print: [
    "astrology",
    "trnk-almond",
    "trnk-espresso",
    "wavy",
    "sand-tide",
    "daisy",
    "cloud",
    "gingham",
    "rosewood-tie-dye",
    "cappuccino-tie-dye",
    "flora",
    "polka-dot",
    "cheetah",
    "things-between",
    "plaid",
    "bloom",
    "confetti",
    "sand-tie-dye",
    "sand-tie-dye-wash",
    "sky-tie-dye",
    "sky-tie-dye-wash",
    "floral",
    "gold-marble",
    "retro-sunset",
    "leopard",
    "groovy-blue",
    "midnight-marble",
    "milk-marble",
    "palm-leaf",
    "stars",
    "stripe",
    "sunset",
    "terrazzo",
    "mustard-bandana",
    "white-bandana",
    "tutti-fruity",
    "orchid-fields",
    "green-checkerboard",
    "pink-grid",
    "matcha",
    "tea-rose"
  ],
  purple: [
    "lavender",
    "orchid",
    "amethyst",
    "things-between",
    "bloom",
    "orchid-fields",
    "berry",
    "raspberry",
  ],
  green: [
    "pale-green",
    "khaki",
    "modern-abstract",
    "palm",
    "green-apple",
    "kiwi",
    "honeydew",
    "pistachio",
    "sage",
    "jade",
    "kale",
    "forest",
    "celery",
    "juniper",
    "daisy",
    "emerald",
    "mint",
    "sage",
    "hue-olive",
    "kaya-olive",
    "palm-leaf",
    "moss",
    "groovy-blue",
    "olive",
    "green-checkerboard",
    "key-lime",
    "matcha",
    "pine"
  ],
  blue: [
    "astrology",
    "aqua",
    "lagoon",
    "hydrangea",
    "marine",
    "winter-sky",
    "cloud",
    "mist",
    "arctic",
    "periwinkle",
    "cobalt",
    "atlantic",
    "glacier",
    "things-between",
    "sky-tie-dye",
    "sky-tie-dye-wash",
    "denim",
    "navy",
    "deep-sea",
    "sky",
    "groovy-blue",
    "wild-n-free",
    "wild-free",
    "wild-n-free",
    "fly-girl",
    "palm-leaf",
    "stars",
    "sunset",
    "bermuda",
    "bluebell",
    "powder-blue",
    "bluebell",
    "indigo",
  ],
  orange: [
    "orange",
    "papaya",
    "orange-grid",
    "retro-sunset",
    "pumpkin",
    "canyon",
    "persimmon",
    "coral",
    "clay"
  ],
  metallic: ["bronze", "kaya-bronze", "gold", "silver", "rose-gold", "copper", "metallic-red"],
  white: [
    "white",
    "white-sands",
    "linen",
    "dove-grey",
    "bloom",
    "sky-tie-dye",
    "sky-tie-dye-wash",
    "white-bandana",
    "confetti",
    "cream",
    "gold-marble",
    "milk-marble",
    "terrazzo",
    "stone",
  ],
  yellow: [
    "celery",
    "mustard-bandana",
    "honey",
    "gold",
    "stripe",
    "sunset",
    "pear",
    "lemonade",
    "dijon",
    "yellow",
    "butter",
    "sunshine",
  ],
  grey: [
    "grey",
    "taupe",
    "charcoal-grey",
    "trnk-grey",
    "cool-grey",
    "charcoal",
    "iron",
    "dove-grey",
    "slate",
    "silver-stardust",
    "ash",
  ],
  red: [
    "red",
    "brick",
    "watermelon",
    "terracotta",
    "rose",
    "merlot",
    "rosewood",
    "retro-sunset",
    "poppy",
    "burgundy",
    "sedona",
    "maroon",
    "pink-grid",
    "cabernet",
    "rouge",
    "metallic-red",
    "clay"
  ],
};

const seachSynonymsTerms = [
  "purple",
  "wandr",
  "cyprus",
  "computer",
  "animal",
  "leopard",
  "round",
  "suitcase",
  "usb",
  "floral",
  "malden",
  "tustin",
  "indio",
  "diaper",
  "baby",
  "hatbox",
  "passport",
  "toiletries",
  "merch",
  "back",
  "sunglasses",
  "bloom",
  "flame",
  "cacao",
  "storm",
];
const seachSynonymsValues = [
  "lavender",
  "hue",
  "hue",
  "laptop",
  "cheetah",
  "cheetah",
  "hat box",
  "luggage",
  "power",
  "hue",
  "hue",
  "hue",
  "luka duffel",
  "luka duffel",
  "hat box",
  "kaya wallet",
  "passport",
  "toiletry",
  "merchandise",
  "backpack",
  "travel accessories",
  "daisy",
  "flame",
  "cacao",
  "storm",
];

const collectionarray = [
  "Best Sellers",
  "Work essentials",
  "New Arrivals",
  "Travel Essentials",
  "Back to School",
  "Back to College",
  "Packing Cubes",
  "Summer Arrivals",
  "Apparel",
  "checked",
  "cross body bag",
  "crossbody",
  "carry-on",
  "cosmetics case",
  "makeup",
  "Baby",
  "Baby Collection",
];
const lowercaseArray = collectionarray.map((item) => item.toLowerCase());

const collectionslug = [
  "best-sellers",
  "back-to-office",
  "new-arrivals",
  "travel-essentials",
  "back-to-school",
  "back-to-college",
  "packing-cubes",
  "summer-arrivals",
  "apparel",
  "checked-in-luggage",
  "crossbody-bags",
  "crossbody-bags",
  "carry-on-luggage",
  "makeup-bags",
  "makeup-bags",
  "baby-collection",
  "baby-collection",
];
let searchInput = document.querySelectorAll(".search-input");
let searchForms = document.querySelectorAll(".search-form");
let searchOverlay = document.querySelector(".search-popup__overlay");
let searchThrottle = false;
let lastSearch = false;
let ga_send_timeout = false;

searchForms.forEach((searchForm) =>
  searchForm.addEventListener("submit", function (e) {
    e.preventDefault();
    this.querySelector(".search-input").blur();
  })
);

function similarity(s1, s2) {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }

  return (
    (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength)
  );
}

function similarity2(s1, s2) {
  let split1 = s1.split(" ");
  let split2 = s2.split(" ");
  let sum = 0,
    max = 0,
    temp = 0;

  for (var i = 0; i < split1.length; i++) {
    max = 0;
    for (var j = 0; j < split2.length; j++) {
      temp = similarity(split1[i], split2[j]);
      if (max < temp) max = temp;
    }
    sum += max / split1.length;
  }

  if (sum == 1 && s1.length != s2.length) sum = 0.95;
  return sum;
}

function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = [];
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0) costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1)) {
            if (
              (i > 1 &&
                j > 1 &&
                s1.charAt(i - 2) == s2.charAt(j - 1) &&
                s1.charAt(i - 1) == s2.charAt(j - 2)) ||
              (s1.length > i &&
                s2.length > j &&
                s1.charAt(i) == s2.charAt(j - 1) &&
                s1.charAt(i - 1) == s2.charAt(j)) // newValue += 0.5;
            );
            else newValue = Math.min(newValue, lastValue, costs[j]) + 1;
          }

          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }

  return costs[s2.length];
}

function getOneVariant(variants, sale) {
  if (!sale) return variants[0];
  else
    for (let i = 0; i < variants.length; i++)
      if (variants[i].compare_at_price * 1 > variants[i].price * 1)
        return variants[i];
  return false;
}

function getMatchedVariants(
  product,
  search,
  colors,
  visible_variants,
  ambiguity,
  or,
  sale
) {
  let best_match = [];

  // The amount Sim affects the order
  let orderAffectedBySim = 1;

  // If the search is empty
  if (search.length == 0 && colors.length == 0) {
    let one_variant = getOneVariant(visible_variants, sale);
    if (!one_variant) return false;
    return [0.66, one_variant, orderAffectedBySim];
  }

  // Searching for words in text
  if (search.length > 0) {
    let search_strings = search;

    // Searching for strings separately
    if (!or) search_strings = [search.join(" ")];

    let prod_title = product.title
      .toLowerCase()
      .replace(" and ", " ")
      .replace("-", " ");
    let prod_type = product.type.toLowerCase().replace("-", " ");
    let prod_vendor = product.vendor.toLowerCase().replace("-", " ");
    let check_body_laptop = false;
    let check_body_fanny = false;

    for (let i = 0; i < search_strings.length; i++) {
      let search_str = search_strings[i];

      let title_sim = 0;
      if (!or) {
        let title_explode = prod_title.split(" ");
        for (let j = 0; j < title_explode.length; j++) {
          if (search.indexOf(title_explode[j]) > -1) title_sim = 0.93;
          break;
        }
      }

      if (title_sim == 0) {
        if (prod_title.indexOf(search_str) > -1)
          title_sim = 0.9 - 0.004 * prod_title.indexOf(search_str);
        else title_sim = similarity2(search_str, prod_title);
      }

      let type_sim = similarity2(search_str, prod_type) * 0.85;
      let vendor_sim = similarity2(search_str, prod_vendor) * 0.85;

      // NB TODO product.body_html || product.description
      let max_val = Math.max(type_sim, title_sim, vendor_sim);
      if (!check_body_laptop) {
        check_body_laptop = similarity2("laptop", search_str) > 0.8;
        if (check_body_laptop)
          max_val = Math.max(
            max_val,
            // similarity2(search_str, product.body_html.toLowerCase())
            similarity2(search_str, product.body_html ? product.body_html.toLowerCase() : product.description.toLowerCase())
          );
      }
      if (!check_body_fanny) {
        check_body_fanny = similarity2("fanny", search_str) > 0.8;
        if (check_body_fanny)
          max_val = Math.max(
            max_val,
            similarity2(search_str, product.body_html ? product.body_html.toLowerCase() : product.description.toLowerCase())
          );
      }

      if (max_val > 0.67) {
        if (max_val > title_sim && title_sim > 0.66) max_val *= 1.1;

        if (best_match.length == 0 || best_match[0] < max_val)
          best_match = [
            max_val,
            getOneVariant(visible_variants, sale),
            orderAffectedBySim * 1.5,
            i,
          ];
      }
    }

    if (best_match.length == 0) {
      if (check_body_laptop) {
        for (let i = 0; i < search.length; i++) {
          if (product.body_html && product.body_html.indexOf("laptop") > -1 || product.description.indexOf("laptop") > -1) {
            best_match = [
              0.67,
              getOneVariant(visible_variants, sale),
              orderAffectedBySim * 1.5,
              i,
            ];
            break;
          }
        }
      } else if (check_body_fanny) {
        for (let i = 0; i < search.length; i++) {
          if (product.body_html && product.body_html.indexOf("fanny") > -1 || product.description.indexOf("fanny") > -1) {
            best_match = [
              0.67,
              getOneVariant(visible_variants, sale),
              orderAffectedBySim * 1.5,
              i,
            ];
            break;
          }
        }
      }
    }

    // If nothing found, and the search is not ambiguous -- return false
    if ((!ambiguity && best_match.length == 0) || best_match[1] === false)
      return false;
  }

  if (colors.length > 0) {
    let color_match = [];
    for (let j = 0; j < colors.length; j++) {
      let search_word = colors[j];

      // Main color search
      for (let i = 0; i < visible_variants.length; i++) {
        let variant = visible_variants[i];
        let option1 = calpak.handleize(variant.option1);

        const sim = similarity2(search_word, option1) - j * 0.02;
        if (
          (!sale || variant.compare_at_price * 1 > variant.price * 1) &&
          sim > 0.9 &&
          (color_match.length == 0 || color_match[0] < sim)
        ) {
          color_match[0] = sim;
          color_match[1] = variant;
          color_match[2] = orderAffectedBySim;

          if (sim == 1) break;
        }
      }

      // Backup related color search
      if (color_match.length == 0)
        for (let i = 0; i < visible_variants.length; i++) {
          let variant = visible_variants[i];
          let option1 = calpak.handleize(variant.option1);

          for (var key in color_groups_search) {
            const sim =
              similarity2(search_word, key.replace("-", " ")) - j * 0.02;
            if (
              (!sale || variant.compare_at_price * 1 > variant.price * 1) &&
              sim > 0.9 &&
              (color_match.length == 0 || color_match[0] < sim)
            ) {
              for (let k = 0; k < color_groups_search[key].length; k++) {
                if (color_groups_search[key][k] == option1) {
                  color_match[0] = sim * 0.9;
                  color_match[1] = variant;
                  color_match[2] = orderAffectedBySim;
                }
              }
            }
          }
        }
    }

    if (!ambiguity && best_match.length > 0 && color_match.length == 0)
      return false;
    else if (color_match.length > 0) {
      if (best_match.length == 0) {
        best_match = color_match;
        best_match[3] = 0;
      } else best_match[1] = color_match[1];
    }
  }

  if (
    best_match.length == 0 ||
    best_match[0] <= 0.66 ||
    best_match[1] === false
  )
    return false;
  return best_match;
}

function calculateProductRelevanceScore(product, searchQuery) {
  let score = 0;

  const normalizedQuery = searchQuery.toLowerCase();
  const normalizedProductTitle = product.title.toLowerCase();

  // Prioritize products containing 'bottle', 'holder', or 'bottle holder'
  if (normalizedProductTitle.includes('bottle holder')) {
      score += 50; // Highest priority
  } else if (normalizedProductTitle.includes('bottle') || normalizedProductTitle.includes('holder')) {
      score += 40; // Medium priority
  }

  // Further scoring based on exact or partial matches
  if (normalizedProductTitle === normalizedQuery) {
      score += 30; // Exact match
  } else if (normalizedProductTitle.includes(normalizedQuery)) {
      score += 20; // Partial match
  }

  // Log the score for debugging
  // console.log(`Product: ${product.title}, Relevance Score: ${score}, Query: ${searchQuery}, Title: ${normalizedProductTitle}`);

  return score;
}

function createSearchItem(
  product,
  available,
  matchedVariant,
  products_target,
  productorder = 500,
  searchQuery = ''
) {
  const relevanceScore = calculateProductRelevanceScore(product, searchQuery);

  // Adjust the product order based on the relevance score
  productorder -= relevanceScore * 10; // Adjust multiplier to fit your needs

  let newItem = document.createElement("div");
  newItem.classList.add("search-result__product");
  newItem.setAttribute("role", "group");
  newItem.setAttribute("aria-label", "product");
  newItem.setAttribute("id", `product-wrap--${product.handle}`);
  let variant = "";
  if (matchedVariant[1]) variant = calpak.handleize(matchedVariant[1].option1);

  products_target.appendChild(newItem);

  fetch(`/products/${product.handle}/${variant}?view=unit`)
    .then((response) => response.text())
    .then((data) => {

      // ADA pause gifs for reduced motion
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        data = data.replace(/\.gif\?/g, '.gif?format=jpg&')
      }

      newItem.innerHTML = data;
      const productUnit = newItem.querySelector(".product-unit");

      if (calpak.productUnitsObserver && productUnit)
        calpak.productUnitsObserver.observe(productUnit);

      const qv = productUnit.querySelector(".quick-view__link");
      if (qv) qv.addEventListener("click", calpak.quickViewClick);

      const applyActiveSwatch = () => {
        const allSwatches = newItem.querySelectorAll('.color-swatch');
        for (const swatch of allSwatches) {
          let attr = swatch.getAttribute("title").toLowerCase();
          attr = attr.replace(/\s+/g, '-');
          if (variant && attr) {
            if (attr === variant) {
              swatch.classList.add('color-swatch--active');
              break;
            } else {
              swatch.classList.remove('color-swatch--active');
            }
          }
        }
      };

      applyActiveSwatch();

      const observer = new MutationObserver(() => {
        applyActiveSwatch();
      });

      observer.observe(newItem, { childList: true, subtree: true });
    });

  newItem.style.order = productorder;
}

function multiSearchOr(text, searchWords) {
  var regex = searchWords.map((word) => "(?=.*\\b" + word + "\\b)").join("");
  var searchExp = new RegExp(regex, "gi");
  return searchExp.test(text) ? true : false;
}

const productfirst = [
  "Compression Packing Cubes",
  "Mini Clear Cosmetics Case",
  "Clear Cosmetics",
  "Terra Toiletry Bag",
  "Tech Organizer",
  "Hue Carry-On",
  "Hue Mini Carry-On",
];
const productfirstlowsercase = productfirst.map((item) => item.toLowerCase());
function searchProductsForMatches(
  products,
  search,
  color_search,
  ambiguity,
  or,
  sale,
  products_target,
  el
) {
  let found = 0;
  for (let i = 0; i < products.length; i++) {
    let product = products[i];

    if (
      product.price == 0 ||
      product.tags.indexOf("do not display") > -1 ||
      product.tags.indexOf("Do not display other-place") > -1
    )
      continue;

    let hide = [];
    let preorder = false;
    product.tags.forEach((tag) => {
      if (tag.substring(0, 5) == "hide:")
        hide.push(...tag.substring(5).toLowerCase().split(";"));
      else if (tag.substring(0, 13) == "early-access:")
        hide.push(...tag.substring(5).toLowerCase().split(";"));
      else if (tag == "preorder" || tag.substring(0, 9) == "preorder:") {
        let explode = tag.split(":");
        if (explode.length < 3) preorder = true;
        else preorder = explode[2].split(";");
      }
    });

    let visible_variants = [];
    let count_available = 0;
    // Getting all variants
    product.variants.forEach((variant) => {
      let option1 = calpak.handleize(variant.option1);

      if (hide.indexOf(option1) === -1) {
        visible_variants.push(variant);
        if (variant.available) count_available++;
      }
    });

    let matchedVariant = getMatchedVariants(
      product,
      search,
      color_search,
      visible_variants,
      ambiguity,
      or,
      sale
    );

    if (!matchedVariant) continue;

    found++;
    var producttitle = product.title.toLowerCase();
    let productorder;

    if (producttitle == el.toLowerCase()) {
      productorder = 1;
    } else if (
      el.toLowerCase() ==
      "small clear cosmetics case + medium clear cosmetics case"
    ) {
      if (producttitle.includes("small") || producttitle.includes("medium")) {
        productorder = 1;
      }
    } else if (
      el.toLowerCase() ==
      "medium clear cosmetics case + small clear cosmetics case"
    ) {
      if (producttitle.includes("medium clear cosmetics case")) {
        productorder = 1;
      }
      if (producttitle.includes("small clear cosmetics case")) {
        productorder = 2;
      }
    } else if (el.toLowerCase() == "backpack") {
      if (producttitle.includes("kaya")) {
        productorder = 1;
      }
    } else if (el.toLowerCase() == "travel backpack") {
      if (producttitle.includes("travel")) {
        productorder = 1;
      }
    } else if (
      el.toLowerCase() == "baye small hat box" ||
      el.toLowerCase() == "baye mini"
    ) {
      if (producttitle.includes("small hat box")) {
        productorder = 1;
      }
    } else if (el.toLowerCase() == "tech organizer") {
      if (producttitle.includes("tech organizer")) {
        productorder = 1;
      }
      if (producttitle.includes("laptop sleeve")) {
        productorder = 2;
      }
    } else if (el.toLowerCase() == "mini clear cosmetics case") {
      if (producttitle == "small clear cosmetics case") {
        productorder = 1;
      }
    } else if (el.toLowerCase() == "large" || el.toLowerCase() == "medium") {
      if (producttitle.includes("luggage")) {
        productorder = 1;
      }
      if (producttitle.includes("hat box")) {
        productorder = 2;
      }
    } else if (producttitle.includes(el.toLowerCase())) {
      productorder = 2;
    } else if (el.toLowerCase() == "terra toiletry bag") {
      if (producttitle == "terra hanging toiletry bag") {
        productorder = 3;
      }
    }

    if (el.toLowerCase() == "shoe compartment") {
      if (producttitle == "luka mini backpack") {
        product = "";
      }
    }
    if (product != "") {
      createSearchItem(
        product,
        count_available > 0,
        matchedVariant,
        products_target,
        productorder
      );
    }
  }

  return found;
}

function fillSearchProducts(
  results,
  container,
  search,
  color_search,
  ambiguity,
  or,
  sale,
  el
) {
  const products_target = container.querySelector(
    '.search-section[data-id="results"] .products__grid'
  );
  if (products_target && typeof results != "undefined") {
    const products = results;
    products_target.innerHTML = "";

    let products_found = 0;

    // Looking for both SEARCH and COLOR terms
    products_found = searchProductsForMatches(
      products,
      search,
      color_search,
      ambiguity,
      or,
      sale,
      products_target,
      el
    );

    if (search.length > 0 && color_search.length > 0) {
      // If nothing found -- ignore colors and look for SEARCH terms only
      if (products_found == 0)
        products_found = searchProductsForMatches(
          products,
          search,
          [],
          ambiguity,
          or,
          sale,
          products_target,
          el
        );

      // If nothing found -- ignore search and look for COLOR terms only
      if (products_found == 0)
        products_found = searchProductsForMatches(
          products,
          [],
          color_search,
          ambiguity,
          or,
          sale,
          products_target,
          el
        );
    }

    if (products_found == 0) container.setAttribute("data-status", "empty");
    else {
      searchtitle.style.display = "block";
      //mobilesearchTitle.classList.add = 'show_mobile';
      const searchNums = container.querySelectorAll(".search-num");
      searchNums.forEach((searchNum) => (searchNum.innerHTML = products_found));
      container.setAttribute("data-status", "results");
    }
  }
}

function fillSearchResults(results, container, searchparam) {
  const collectionsTarget = container.querySelector(
    ".content-section--collections"
  );
  let collectionsFound = 0;
  let searchparameter = searchparam;

  const productUnit = document.querySelectorAll(".product-unit__swatches .color-swatch");

  const applyActiveSwatch = () => {
    for (const swatch of productUnit) {
      let attr = swatch.getAttribute("data-value").toLowerCase();
      attr = attr.replace(/\s+/g, '-');
      if (searchparam && attr) {
        if (attr === searchparam) {
          swatch.classList.add('color-swatch--active');
          break;
        } else {
          swatch.classList.remove('color-swatch--active');
        }
      }
    }
  };

  applyActiveSwatch();

  const observer = new MutationObserver(() => {
    applyActiveSwatch();
  });

  observer.observe(container, { childList: true, subtree: true });

  if (collectionsTarget && typeof results.collections != "undefined") {
    const collections = results.collections;
    const collectionsTargetGrid =
      collectionsTarget.querySelector(".search__cards");

    collectionsTargetGrid.innerHTML = "";
    let uniqueCollections = new Set();

    for (let i = 0; i < collections.length; i++) {
      let collection = collections[i];

      // perform checks to see if collection should be hidden
      if (collection.title.toLowerCase().indexOf("early access") > -1) continue;
      if (collection.body && collection.body.indexOf("hide in search") > -1) continue;
      if (collection.description && collection.description.indexOf("hide in search") > -1) continue;
      if (uniqueCollections.has(collection.title)) continue;

      uniqueCollections.add(collection.title);

      collectionsFound++;

      let newItem = document.createElement("a");
      newItem.classList.add("search__card");
      if (collection.url) {
        newItem.setAttribute("href", collection.url);
      } else {
        newItem.setAttribute("href", `/collections/${collection.handle}`);
      }

      let img = "";
      if (collection.featured_image) {
        if (
          collection.featured_image != null &&
          typeof collection.featured_image != "undefined" &&
          collection.featured_image.url != null
        ) {
          img = calpak.getImage(
            collection.featured_image.url,
            "400px",
            collection.title
          );
        }
      } else {
        if (typeof collection.image != "undefined" && collection?.image != null) {
          img = calpak.getImage(collection.image, "400px", collection.title);
        }
      }

      newItem.innerHTML = `<div class="search__card-image">${img}</div>
  <div class="search__card-title">${collection.title}</div>`;
      collectionsTargetGrid.appendChild(newItem);
    }

    const searchNums = container.querySelectorAll(".search-col-num");
    if (collectionsFound > 0)
      searchNums.forEach(
        (searchNum) => (searchNum.innerHTML = collectionsFound)
      );
  }
  if (typeof results.pages != "undefined") {
    const pages = results.pages;
    var pagegrid = container.querySelector(".pages-grid");
    searchtitle.style.display = "none";
    mobilesearchTitle.style.setProperty("display", "none");
    if (pages.length > 0) {
      container.setAttribute("data-status", "results");
      for (let i = 0; i < pages.length; i++) {
        let page = pages[i];
        if (searchparameter.toLowerCase() == "warranty") {
          pagegrid.innerHTML = `<div class="pages-grid-inner"><a href="/pages/${page.handle}#faq--warranty"><h2>${page.title}</h2><p>${page.body}</p></a></div>`;
        } else {
          pagegrid.innerHTML = `<div class="pages-grid-inner"><a href="/pages/${page.handle}"><h2>${page.title}</h2><p>${page.body}</p></a></div>`;
        }
      }
    }
  } else {
    toggle();
    window.onresize = function () {
      toggle();
    };
    function toggle() {
      if (window.innerWidth < 900) {
        mobilesearchTitle.style.setProperty("display", "block");
      }
    }
    var pagegrid = container.querySelector(".pages-grid");
    pagegrid.innerHTML = "";
  }

  if (collectionsFound == 0) container.classList.add("menu-popup--no-side");
}

function colorMatch(word) {
  let limit = 0.75;
  let results = [];

  if (word == "on" || word == "silk" || word == "hand" || word == "robe" || word == "pin")
    return false;

  for (var key in color_groups_search) {
    let sim = similarity2(word, key.replace("-", " "));

    if (sim >= limit) {
      results.push([key, sim]);
    }

    for (let j = 0; j < color_groups_search[key].length; j++) {
      if (
        color_groups_search[key][j].indexOf("luka-") === 0 ||
        color_groups_search[key][j].indexOf("hue-") === 0 ||
        color_groups_search[key][j].indexOf("jen-") === 0 ||
        color_groups_search[key][j].indexOf("ambeur-") === 0 ||
        color_groups_search[key][j].indexOf("kaya-") === 0 ||
        color_groups_search[key][j].indexOf("trnk-") === 0
      )
        continue;

      let sim = similarity2(
        word,
        color_groups_search[key][j].replace("-", " ")
      );

      if (sim >= limit) {
        results.push([color_groups_search[key][j], sim]);
      }
    }
  }

  if (results.length == 0) return false;
  return results;
}

function searchProcessQuery(split) {
  let or = false;

  if (split.indexOf("print") > -1) {
    if (split.indexOf("animal") > -1) split.splice(split.indexOf("print"), 1);
  }

  if (split.indexOf("bag") > -1) {
    if (
      split.indexOf("diaper") > -1 ||
      split.indexOf("daiper") > -1 ||
      split.indexOf("makeup") > -1
    )
      split.splice(split.indexOf("bag"), 1);
  }
  let unsplited = split.join(" ");

  if (similarity2("weekender bag", unsplited) >= 0.95) {
    split = ["duffel", "vanity", "small hat"];
    or = true;
  } else if (similarity2("weekender", unsplited) >= 0.9) {
    split = [
      "duffel",
      "vanity",
      "hue carry-on",
      "ambeur carry-on",
      "kaya lapt backpack",
      "luka lapt backpack",
      "neck pillow",
    ];
    or = true;
  }

  if (
    similarity2("cross", unsplited) > 0.9 ||
    similarity2("crossbody", unsplited) > 0.9
  ) {
    split = ["wallet", "belt", "water", "Stevyn Mini Crossbody Bag"];
    split = ['Convertible Stroller Caddy Crossbody'];
    or = true;
  }

  if (
    similarity2("Underseat", unsplited) > 0.9 ||
    similarity2("Under seat", unsplited) > 0.9
  ) {
    split = ["Mini carry"];
    or = false;
  }

  if (similarity2("car organizer", unsplited) >= 0.9) {
    split = ["car organizer", "tech organizer", "compakt zipper"];
    or = true;
  } else if (similarity2("organizer", unsplited) >= 0.9) {
    split = ["organizer", "cubes", "case", "toiletry"];
    or = true;
  }

  if (similarity2("purse", unsplited) > 0.9) {
    split = ["tote", "kaya wallet"];
    or = true;
  }

  if (
    similarity2("lunch", unsplited) > 0.9 ||
    similarity2("lunchbox", unsplited) > 0.9
  ) {
    split = ["lunch"];
  }

  if (similarity2("cover", unsplited) >= 0.95) {
    split = ["clear luggage cover", "atkin"];
    or = true;
  }

  if (similarity2("vanity case", unsplited) >= 0.9) {
    split = ["vanity case", "clear cosmetics"];
    or = true;
  }

  if (similarity2("shoe compartment", unsplited) >= 0.9) {
    split = [
      "shoe compartment",
      "luka duffel",
      "stevyn duffel",
      "luka backpack",
    ];
    or = true;
  }

  if (similarity2("cosmetics case", unsplited) >= 0.9) {
    split = ["cosmetics", "hat", "hue toiletry", "luka toiletry"];
    or = true;
  }

  if (similarity2("travel backpack", unsplited) >= 0.95) {
    split = ["backpack"];
    or = true;
  }

  if (similarity2("makeup", unsplited) >= 0.95) {
    split = ["cosmetics", "hat", "toiletry"];
    or = true;
  }

  if (similarity2("baye small hat box", unsplited) >= 0.95) {
    split = ["hat box", "small", "hat"];
    or = true;
  }
  if (similarity2("baye mini", unsplited) >= 0.95) {
    split = ["hat box", "baye mini"];
    or = true;
  }
  return [split, or];
}

async function fillCollectionSearch(handles, container) {
  const collections = calpak.collections.whereIn('handle', handles).where('hide', false).all();

  let productIds = []
  collections.forEach((collection) => {
    if (collection.hide !== true) {
      productIds = productIds.concat(collection.products)
    }
  })
  // console.log('productIds',productIds)
  const collection = collect(productIds);
  const uniqueProductIds = collection.unique().all()
  // console.log('uniqueProductIds', uniqueProductIds)
  const products = calpak.products.whereIn('id', uniqueProductIds).all();

  if (typeof products != "undefined" && products != null && products.length > 0) {
    searchtitle.style.display = "block";
    const searchNums = container.querySelectorAll(".search-num");
    searchNums.forEach(
        (searchNum) => (searchNum.innerHTML = products.length)
    );

    const products_target = container.querySelector(
        '.search-section[data-id="results"] .products__grid'
    );
    products_target.innerHTML = "";
    container.setAttribute("data-status", "results");

    products.forEach((product) => {
      createSearchItem(
          product,
          product.available,
          [0, false],
          products_target
      )
    })

  } else {
    console.log('not (products.length > 0')
    container.setAttribute("data-status", "empty");
  }

}

const searchPopupLayout = (s = "") => {
  const searchContainer = document.querySelector('.search-popup__content');
  const allSearchResults = document.querySelectorAll('.search-result__product');
  const allCollectionResults = document.querySelectorAll('.search__card');

  if (!searchContainer) return; // Ensure searchContainer exists

  const isWideScreen = window.innerWidth >= 1180;
  const hasResults = allSearchResults.length > 0;
  const hasCollection = allCollectionResults.length > 0;
  
  let collectionMenu = document.querySelector('.menu-popup--search');
  const sideCollectionMenu = collectionMenu && collectionMenu.classList.contains("menu-popup--no-side");
  const requiresFullHeight = isWideScreen ? hasResults || hasCollection : true;

  // Determine if the height needs to be set to 100%
  const shouldSetHeightToFull = sideCollectionMenu || requiresFullHeight;

  if (shouldSetHeightToFull) {
    if (searchContainer.style.height !== "100%") {
      searchContainer.style.height = "100%";
    }
  } else {
    if (searchContainer.style.height !== "initial") {
      searchContainer.style.height = "initial";
    }
  }

  // Force a reflow to ensure height is applied
  searchContainer.offsetHeight;
};

const initializeLayout = () => {
  requestAnimationFrame(() => {
    searchPopupLayout();
  });
};

initializeLayout();

window.addEventListener("resize", () => {
  initializeLayout();
});

// Also listen for the window focus event to handle the inspect tool closing case
window.addEventListener("focus", () => {
  initializeLayout();
});

function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const debouncedSearchPopupLayout = debounce(searchPopupLayout, 800);

async function performSearch(el) {

  let s = el.value.trim();
  debouncedSearchPopupLayout();

  // Send GTM search event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "search",
    search_term: s,
  });

  const form = el.closest(".search-form");
  const container = form.closest(".menu-popup--search");

  let terms = container?.querySelectorAll(".search-term");
  terms?.forEach((term) => (term.innerHTML = calpak.stripHTML(s)));
  let formattedSearchQuery = s.toLowerCase().split(/[- ]+/);

  if (
    (formattedSearchQuery.includes("insulated") && formattedSearchQuery.includes("bag")) ||
    (formattedSearchQuery.includes("insulated") && formattedSearchQuery.includes("bags")) ||
    (formattedSearchQuery.includes("lunch") && formattedSearchQuery.includes("bag")) ||
    (formattedSearchQuery.includes("lunch") && formattedSearchQuery.includes("bags"))
  ) s = "lunch";

  formattedSearchQuery = s.toLowerCase().split(/[- ]+/);

  let isPortable = formattedSearchQuery.includes("portable");
  let isLunchBag = formattedSearchQuery.includes("lunch");
  let isGymBag = formattedSearchQuery.includes("gym");
  let isDoppkit = formattedSearchQuery.includes("dopp");
  let isMiniBag = s.toLowerCase() === "mini";
  let isBackpack = s.toLowerCase() === "back";
  let isWorkCollection = formattedSearchQuery.includes("work") || formattedSearchQuery.includes("office");
  let isPassThroughCollection = formattedSearchQuery.includes("pass") || formattedSearchQuery.includes("through")  || formattedSearchQuery.includes("passthrough");
  let isFamilyShow = formattedSearchQuery.includes("family");
  let isTerraHydration = formattedSearchQuery.includes("hydration");
  let isPersonalItem = formattedSearchQuery.includes("personal");
  let isLaptop = s.toLowerCase() === "laptop";
  let isSuitcase = s.toLowerCase() == "suitcase" || s.toLowerCase() == "suitcases";
  let isLuggage = s.toLowerCase() == "luggage" || s.toLowerCase() == "luggages";

  const bagTypes = {
    lunch: "lunch bag",
    gym: "gym-bag",
    dopp: "dopp-kit",
    yoga: "yoga-bag",
  };

  let isBagType = Object.keys(bagTypes).find(type => formattedSearchQuery.includes(type));

  function createWordSet(text) {
    return new Set(text.trim().toLowerCase().split(/[- ]+/).map(normalizeWord));
  }

  function normalizeWord(word) {
    return word.endsWith('s') ? word.slice(0, -1) : word;
  }

  function extractNumericPart(text) {
    const regex = /(\d+)([a-zA-Z]*)/g;
    const matches = [];
    let match;
    while ((match = regex.exec(text)) !== null) {
      matches.push({ number: match[1], unit: match[2].toLowerCase() });
    }
    return matches;
  }

  function matchesSearchCriteria(value, searchWords) {
    let titleWords = new Set();

    const numericParts = extractNumericPart(Array.from(searchWords).join(" "));
    for (let part of numericParts) {
      if (value.title.includes(part.number) && value.title.toLowerCase().includes(part.unit)) {
        return true;
      }
    }

    if (isBagType) {
      let tagToCheck = bagTypes[isBagType];
      value.tags.forEach(tag => {
        if (tag.toLowerCase() === tagToCheck) {
          titleWords = createWordSet(tag);
        }
      });
    } else if (isMiniBag) {
      value.tags.forEach(tag => {
        if (tag.toLowerCase() === "mini-carry-on") {
          titleWords = createWordSet(tag);
        }
      });
    } else if (isPersonalItem) {
      value.tags.forEach(tag => {
        if (tag.toLowerCase() === "personal item") {
          titleWords = createWordSet(tag);
        }
      });
    } else if (isFamilyShow) {
      value.tags.forEach(tag => {
        if (tag.toLowerCase() === "family-show") {
          titleWords = createWordSet(tag);
        }
      });
    } else if (isTerraHydration) {
      titleWords = createWordSet(value.handle);
    }
    else {
      titleWords = createWordSet(value.title);
    }

    const updatedSearchWords = [...searchWords].map(word => {
      return word.toLowerCase() === 'suitcase' ? 'luggage' : word;
    });

    if (isBagType || isMiniBag || isFamilyShow || isSuitcase || isLuggage) {
      if (titleWords.has("portable")) return false; 
      return updatedSearchWords.some(word => titleWords.has(word));
    }

    if(formattedSearchQuery.includes("suitcases")) {
      if (titleWords.has("portable")) return false; 
    }

    return updatedSearchWords.every(word => titleWords.has(word));
  }

  function fetchProducts() {
    const products = calpak.products.all();

    function calculateProductRelevanceScore(product) {
      let score = 0;
      const queryWords = s.toLowerCase().split(" ");
      const productTitle = product.title.toLowerCase();
  
      queryWords.forEach((word) => {
        if (productTitle.includes(word)) {
          score += 10;
        }
      });
  
      if (productTitle.includes("laptop") && productTitle.includes("padded") && productTitle.includes("sleeve")) {
        score += 20;
      }
  
      return score;
    }

    const filteredData = products.filter(value => {
      let searchWords = createWordSet(s);
      return matchesSearchCriteria(value, searchWords);
    }).sort((a, b) => calculateProductRelevanceScore(b) - calculateProductRelevanceScore(a));
    if (filteredData != null && typeof filteredData != "undefined") {
      searchtitle.style.display = "block";
      const searchNums = container.querySelectorAll(".search-num");
      searchNums.forEach(
        (searchNum) => (searchNum.innerHTML = filteredData.length)
      );

      if (filteredData.length > 0) {
        const products_target = container.querySelector(
          '.search-section[data-id="results"] .products__grid'
        );
        products_target.innerHTML = "";
        container.setAttribute("data-status", "results");
        for (let i = 0; i < filteredData.length; i++) {
          createSearchItem(
            filteredData[i],
            filteredData[i].available,
            [0, false],
            products_target
          );
        }
      } else {
        container.setAttribute("data-status", "empty");
      }

      const collectiondata = calpak.collections.where('hide', false).all();
      let searchProductIds = [];

      searchProductIds = filteredData?.map(item => item.id);

      const matchingCollections = collectiondata.filter((collection) => {
        return collection.products.some(productId => searchProductIds.includes(productId));
      });

      function calculateRelevanceScore(collection) {
        let score = 0;
        const queryWords = s.toLowerCase().split(' ');
        const collectionTitle = collection.title.toLowerCase().split(" ");

        const allWordsIncluded = queryWords.some(word => collectionTitle.includes(word));

        if (allWordsIncluded) {
          score += 15;
        }

        const productMatches = collection.products.filter(productId => searchProductIds.includes(productId)).length;
        score += productMatches * 5;
        return score;
      }

      matchingCollections.sort((a, b) => calculateRelevanceScore(b) - calculateRelevanceScore(a));

      if (matchingCollections?.length) {
        let collectionMenu = document.querySelector('.menu-popup--search');
        collectionMenu?.classList.remove("menu-popup--no-side");
        fillSearchResults({ collections: matchingCollections }, container, s);
      }
    }
  }

  const collectiondata = calpak.collections.where('hide', false).all();

  const substitutions = {
    "compact": "compakt",
    "outdoor": "terra",
    "outdoor backpack": "terra backpack",
    "sport": "fit",
    "rolling luggage": "rolling",
    "water bottle pocket": "water bottle",
    "water bottle carrier": "water bottle holder",
    "duffle": "duffel",
    "travel toiletry": "makeup",
    "travel jewelry": "jewelry",
    "travel jewelry case": "jewelry",
    "hard shell suitcases": "hard shell",
    "underseat": "under seat",
    "small spinner": "under seat",
    "small spinner luggage": "under seat",
    "small makeup": "small case",
    "small padded backpack": "luka mini backpack",
    "small laptop backpack": "13 inch",
    "soft small": "luka mini carry on",
    "soft small suitcase": "luka mini carry on",
    "soft small suitcases": "luka mini carry on",
    "large makeup": "large case",
    "medium makeup": "medium case",
    "deal": "sale",
    "deals": "sale",
    "metallic carry luggage": "ambeur carry luggage",
    "water resistant sling": "terra sling",
    "water resistant travel": "terra",
    "carry spinner": "carry luggage",
    "carry on spinner luggage": "carry luggage",
    "luggage bundle": "luggage sets",
    "laptop compartment carry": "front pocket",
    "carry on with laptop compartment": "front pocket",
    "duffel bag with laptop compartment": "hue laptop",
    "laptop compartment duffel": "hue laptop",
    "zipper": "zippered",
    "zipper pouch": "zippered pouch",
    "foldable": "compact duffel",
    "foldable duffel bag": "compakt duffel",
    "large duffel": "luka large",
    "friendly": "laptop",
    "computer": "laptop",
    "luggage deals": "luggage sale",
    "metallic carry on": "ambeur carry on",
    "metallic carry on luggage": "ambeur carry on",
  };

  const applySubstitutions = (searchQuery) => {
    let updatedQuery = searchQuery.toLowerCase();

    const removeLastTrailingBags = (query) => {
      const regex = /\b(?:bag|bags|luggage)\b(?=\s*$)/;
      if (query.match(regex) && query.trim().split(' ').length > 1) {
        return query.replace(regex, "");
      }
      return query;
    };

    for (let [key, value] of Object.entries(substitutions)) {
      const regex = new RegExp(`\\b${key}\\b`, 'gi');
      updatedQuery = updatedQuery.replace(regex, value);
    }

    updatedQuery = removeLastTrailingBags(updatedQuery);
    return updatedQuery.trim();
  };

  const matchingCollections = collectiondata.filter((collection) => {
    const collectionTitleWords = collection.title.toLowerCase().split(" ");
    let searchQueryWords = s.toLowerCase().split(" ");
    
    if (applySubstitutions(s)) {
      s = applySubstitutions(s);
      searchQueryWords = s.toLowerCase().split(" ");
      searchQueryWords = searchQueryWords.filter(word => word.trim() !== "");
    }

    if (isPassThroughCollection) s = "trolley"
    if (isWorkCollection) s = "work"
    if (s.toLowerCase() == "luggage") s = "luggages"

    return searchQueryWords.every((queryWord) =>
      collectionTitleWords.some((collectionWord) =>
        collectionWord.includes(queryWord)
      )
    );
  });

  if (isLunchBag || isPortable) {
    fetchProducts();
  }

  let color_search = false;

  for (let key in color_groups_search) {
    const normalizedKey = key.toLowerCase();
    const normalizedSearch = s.replace(/\s+/g, '-').toLowerCase();

    if (normalizedSearch === normalizedKey || color_groups_search[key].map(color => color.toLowerCase()).includes(normalizedSearch)) {
      color_search = true;
      break;
    }
  }

  if (matchingCollections.length > 0 && s && !color_search) {
    let searchCollectionHandles = [];
    matchingCollections.forEach((element) => {
      const collectionTitleWords = element.title.toLowerCase().split(" ");
      const searchQueryWords = s.toLowerCase().split(" ");
      searchQueryWords.every((queryWord) =>
        collectionTitleWords.some((collectionWord) => {
          if (collectionWord.includes(queryWord)) {
            searchCollectionHandles.push(element.handle);
          }
        })
      );
    });

    const hasEmptyCollections = matchingCollections?.some((collection) => collection?.products?.length <= 0);
    let collectionMenu = document.querySelector('.menu-popup--search');
    const sizes = ["large", "medium", "small"];

    if (hasEmptyCollections) {
      collectionMenu.classList.add("menu-popup--no-side")
      fetchProducts();
    }

    if(isLaptop){
      fetchProducts();
      return;
    }

    if (sizes.some(size => s.toLowerCase().split(/[- ]+/).includes(size)) || isMiniBag || isPortable) {
      collectionMenu.classList.add("menu-popup--no-side")
      fetchProducts();
    } else {
      collectionMenu.classList.remove("menu-popup--no-side")
      let newSearchCollectionHandles = searchCollectionHandles.filter((col) => { 
        return col !=="back-to-school" && col !== "back-in-stock"
      });

      if (isBackpack) {
        fillCollectionSearch(newSearchCollectionHandles, container);
      } else {
        fillCollectionSearch(searchCollectionHandles, container);
      }
      fillSearchResults({ collections: matchingCollections }, container, s);
    }
  } else {
    if (isGymBag || isDoppkit) {
      let collectionMenu = document.querySelector('.menu-popup--search');
      collectionMenu?.classList.add("menu-popup--no-side")
      fetchProducts();
      return;
    }
    if (lastSearch === s) return;
    lastSearch = s;

    sessionStorage.setItem("search", lastSearch);

    if (s.length == 0) return container.setAttribute("data-status", "init");

    container
      .querySelector(".menu-popup__mobile-nav")
      .setAttribute("data-page", 0);

    let search = [];
    let color_search = [];
    let generated_words = 0;
    let ambiguity = false;
    let searchType = "normal";

    let searchTextLC = s.toLowerCase().replace("'s", "s");
    if (lowercaseArray.includes(searchTextLC)) {
      const foundIndex = lowercaseArray.indexOf(searchTextLC);
      const collectionurl = collectionslug[foundIndex];
      const data = await fetch(`/collections.json?limit=250`).then((response) =>
        response.json()
      );
      if (data && data.collections && data.collections.length > 0) {
        let iscollectionslug = data.collections.some(
          (item) => item.handle == collectionurl
        );
        if (!iscollectionslug) {
          searchTextLC = "collection:new-arrivals";
        } else {
          searchTextLC = "collection:" + collectionurl;
        }
      } else {
        searchTextLC = "collection:" + collectionurl;
      }
    }
    if (searchTextLC.indexOf(":")) {
      const searchExpl = searchTextLC.split(":");
      if (searchExpl[0] == "collection") {
        searchType = "collection";
        s = searchExpl[1];
        fillCollectionSearch([searchExpl[1]], container);
        fetch(
          `/search/suggest.json?q=${encodeURIComponent(
            s
          )}&resources[limit_scope]=each&resources[type]=collection&resources[limit]=10`
        )
          .then((response) => response.json())
          .then((response) =>
            fillSearchResults(
              response.resources.results,
              container,
              el.value.trim()
            )
          );
        return;
      }
    }

    let is_color_search = false;

    for (let key in color_groups_search) {
      const normalizedKey = key.toLowerCase();
      const normalizedSearch = s.replace(/\s+/g, '-').toLowerCase();

      if (normalizedSearch === normalizedKey || color_groups_search[key].map(color => color.toLowerCase()).includes(normalizedSearch)) {
        is_color_search = true;
        break;
      }
    }

    if (!seachSynonymsValues.includes(s) && !is_color_search) {
      let collectionMenu = document.querySelector('.menu-popup--search');
      collectionMenu?.classList.add("menu-popup--no-side")
      fetchProducts();
      return;
    }

    let splitInit = searchTextLC.match(/\b(\w+)\b/g);
    if (!splitInit) return;

    var [split, or] = searchProcessQuery(splitInit);
    // Generating word combinations
    if (split.length == 2) {
      split.unshift(searchTextLC);
      generated_words = 1;
    } else if (split.length > 2) {
      let _split = Array.from(split);
      for (let i = 0; i < _split.length - 1; i++) {
        for (let j = i + 1; j < _split.length; j++) {
          generated_words++;
          split.unshift(_split[i] + " " + _split[j]);
        }
      }
    }

    // Synonym replace
    let split_length = split.length;
    for (let i = 0; i < split_length; i++) {
      let word = split[i];
      let escape = false;

      for (let j = 0; j < seachSynonymsTerms.length; j++) {
        if (seachSynonymsTerms[j] == word) {
          if (i < generated_words) {
            split = [seachSynonymsValues[j]];
            generated_words = 0;
            escape = true;
          } else if (split.indexOf(seachSynonymsValues[j]) === -1) {
            split[i] = seachSynonymsValues[j];
          }
          break;
        }
      }
      if (escape) break;
    }

    for (let i = 0; i < split_length; i++) {
      let word = split[i];
      for (let j = 0; j < seachSynonymsTerms.length; j++) {
        if (
          seachSynonymsTerms[j] != word &&
          similarity2(seachSynonymsTerms[j], word) > 0.8
        ) {
          if (split.indexOf(seachSynonymsValues[j]) === -1) {
            split.push(seachSynonymsValues[j]);
            break;
          }
        }
      }
    }

    let gen_color_match = false;
    let sale = false;
    let exclude_from_color = ["mini"];
    for (let i = 0; i < split.length; i++) {
      let word = split[i];
      let color_found = false;

      // Ignore "collection" keyword
      if (similarity2(word, "collection") > 0.8) continue;

      // Search for items on sale only
      if (word == "sale") {
        sale = true;
        continue;
      }

      if (exclude_from_color.indexOf(word) === -1) {
        // Look for color names
        let color_match = colorMatch(word);
        if (color_match !== false && !gen_color_match) {
          color_match.sort(function (a, b) {
            if (a[1] < b[1]) return 1;
            if (a[1] > b[1]) return -1;
            return 0;
          });

          for (let k = 0; k < color_match.length; k++) {
            let matched_color = color_match[k];

            color_search.push(matched_color[0]);

            if (i < generated_words) {
              // Analyzing generated words
              if (matched_color[1] > 0.98) {
                gen_color_match = true;
                break;
              }
            } else if (color_match[1] < 0.85) {
              search.push(word);
              ambiguity = true;
            }
          }

          continue;
        }
      }

      if (!color_found && i >= generated_words) search.push(word);
    }

    if (color_search.length > 1)
      color_search = color_search.filter((x, i, a) => a.indexOf(x) == i);
    if (search.length > 1)
      search = search.filter((x, i, a) => a.indexOf(x) == i);

    if (search.indexOf("pack") > -1) {
      if (search.indexOf("fanny") > -1 || search.indexOf("fany") > -1)
        search.splice(search.indexOf("pack"), 1);
    }

    if (search.indexOf("bag") > -1) {
      if (search.indexOf("laptop") > -1)
        search.splice(search.indexOf("bag"), 1);
      if (search.indexOf("duffle") > -1 || search.indexOf("duffel") > -1)
        search.splice(search.indexOf("bag"), 1);
    }

    if (ga_send_timeout) clearTimeout(ga_send_timeout);
    ga_send_timeout = setTimeout(function () {
      if (lastSearch.length && ga) {
        ga(
          "send",
          "pageview",
          "https://www.calpaktravel.com/pages/search-results-page?q=" +
            encodeURIComponent(lastSearch)
        );

        gtag("event", "page_view", {
          page_title: "Search",
          page_location: window.location.href,
          page_path:
            "https://www.calpaktravel.com/pages/search-results-page?q=" +
            encodeURIComponent(lastSearch),
        });
      }
    }, 2000);

    if (color_search.indexOf("wavy") > -1) {
      search.push("wavy");
      ambiguity = true;
    }

    if (search.length == 0 && color_search.length == 0 && sale == false) {
      container.setAttribute("data-status", "init");
      return;
    }
    let terms = container.querySelectorAll(".search-term");
    terms.forEach((term) => (term.innerHTML = calpak.stripHTML(s)));

    if (searchType == "normal")
      fillSearchProducts(
          calpak.products.all(),
          container,
          search,
          color_search,
          ambiguity,
          or,
          sale,
          el.value.trim()
      );

    //// COLLECTIONS AND ARTICLES ////
    container.classList.remove("menu-popup--no-side");
    if (s.toLowerCase() == "faq" || s.toLowerCase() == "warranty") {
      s = "questions";
      fetch(
        `/search/suggest.json?q=${encodeURIComponent(s)}&resources[limit_scope]=each&resources[type]=page,collection&resources[limit]=10`
      )
        .then((response) => response.json())
        .then((response) =>
          fillSearchResults(
            response.resources.results,
            container,
            el.value.trim()
          )
        );
    } else {
      fetch(
        `/search/suggest.json?q=${encodeURIComponent(s)}&resources[limit_scope]=each&resources[type]=collection&resources[limit]=10`
      )
        .then((response) => response.json())
        .then((response) =>
          fillSearchResults(
            response.resources.results,
            container,
            el.value.trim()
          )
        );
    }
  }
}

function closeHeaderSearch() {
  lastSearch = false;
  document.querySelector(".search-popup__content .menu-close").click();
}

if (searchInput.length) {
  if (searchOverlay) searchOverlay.addEventListener("click", closeHeaderSearch);

  for (let i = 0; i < searchInput.length; i++) {
    searchInput[i].addEventListener("keyup", function (event) {
      debouncedSearchPopupLayout();
      if (searchThrottle !== false) clearTimeout(searchThrottle);

      if (
        (typeof event.key != "undefined" && event.key === "Escape") ||
        event.keyCode === 27
      ) {
        closeHeaderSearch();
        return;
      }

      let el = this;
      searchThrottle = setTimeout(function () {
        if (el.classList.contains("search-input__404")) {
          document
            .querySelector(".menu-popup--search")
            .classList.add("menu-popup--visible");
          document.body.classList.add("modal-open");
          let mainSearchInput = document.querySelector(
            ".menu-popup--search .search-input"
          );
          mainSearchInput.value = el.value;
          el.value = "";
          document.querySelector(".menu-popup--search .search-input").focus();
          el = mainSearchInput;
        }

        performSearch(el);
      }, 300);
    });
  }
}

const searchCategoriesButtons = document.querySelectorAll(
  ".search__collections-buttons .button"
);
searchCategoriesButtons.forEach((searchCategoriesButton) =>
  searchCategoriesButton.addEventListener("click", function (e) {
    e.preventDefault();

    const container = this.closest(".search-popup__content");
    if (!container) return;

    const input = container.querySelector(".search-input");
    if (!input) return;

    const handle = searchCategoriesButton.getAttribute("data-handle");
    input.value = `collection:${handle}`;

    performSearch(input);
  })
);

const mobileNavButtons = document.querySelectorAll(
  ".menu-popup__mobile-nav button"
);
mobileNavButtons.forEach((mobileNavButton) =>
  mobileNavButton.addEventListener("click", function (e) {
    const target = this.getAttribute("data-target");
    this.closest(".menu-popup__mobile-nav").setAttribute("data-page", target);
  })
);

const searchContainer = document.querySelector(".menu-popup--search");
const firstFocusableElementSearch = searchContainer.querySelector(
  ".menu-close--search"
);
const lastFocusableElementSearch = searchContainer.querySelector(
  ".search__collections-buttons > a:last-child"
);
// Close the dialog when 'Escape' key is pressed.
searchContainer.addEventListener("keydown", function (e) {
  if (e.key == "Escape") {
    closeHeaderSearch();
  }
});

// Trap keyboard focus by moving focus to the first or last focusable element when the user tries to tab (or "backwards" tab) past them.
searchContainer.addEventListener("keydown", function (e) {
  if (e.target == firstFocusableElementSearch && e.key == "Tab" && e.shiftKey) {
    e.preventDefault();
    lastFocusableElementSearch.focus();
  } else if (
    e.target == lastFocusableElementSearch &&
    e.key == "Tab" &&
    !e.shiftKey
  ) {
    e.preventDefault();
    firstFocusableElementSearch.focus();
  }
});
